import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-edff704e")

_pushScopeId("data-v-edff704e")
const _hoisted_1 = { class: "d-baccarat-bet-view-root" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_pc_bet_area = _resolveComponent("pc-bet-area")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:25',
        betType: 10,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.bearEightTemp,
        confirmedAMount: _ctx.bearEightFinal,
        allowBet: _ctx.allowBet,
        isGrayMode: !_ctx.allowBetOnB8andD7,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: 
                    _ctx.mWin === 8 || _ctx.mWin === 81 || _ctx.mWin === 82 || _ctx.mWin === 83
                
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "allowBet", "isGrayMode", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:22',
        betType: 11,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.smallTigerTemp,
        confirmedAMount: _ctx.smallTigerFinal,
        allowBet: _ctx.allowBet,
        isGrayMode: _ctx.isTigerGrayMode,
        grayModeError: _ctx.tigerGrayModeError,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: 
                    _ctx.mWin === 10 || _ctx.mWin === 101 || _ctx.mWin === 102 || _ctx.mWin === 103
                
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "allowBet", "isGrayMode", "grayModeError", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:50',
        betType: 12,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.bigTigerTemp,
        confirmedAMount: _ctx.bigTigerFinal,
        isGrayMode: _ctx.isTigerGrayMode,
        grayModeError: _ctx.tigerGrayModeError,
        allowBet: _ctx.allowBet,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: 
                    _ctx.mWin === 9 || _ctx.mWin === 91 || _ctx.mWin === 92 || _ctx.mWin === 93
                
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "isGrayMode", "grayModeError", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:40',
        betType: 13,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.dragonSevenTemp,
        confirmedAMount: _ctx.dragonSevenFinal,
        isGrayMode: !_ctx.allowBetOnB8andD7,
        allowBet: _ctx.allowBet,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: 
                    _ctx.mWin === 7 || _ctx.mWin === 71 || _ctx.mWin === 72 || _ctx.mWin === 73
                
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "isGrayMode", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:11',
        betType: 6,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.bluePairTemp,
        confirmedAMount: _ctx.bluePairFinal,
        allowBet: _ctx.allowBet,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: _ctx.isBluePair
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:12',
        betType: 9,
        offSet: -1,
        chipValue: _ctx.chipValue,
        tempAmount: _ctx.super6Temp,
        confirmedAMount: _ctx.super6Final,
        currentIndex: _ctx.selectedBetArea,
        allowBet: _ctx.allowBet,
        isGrayMode: _ctx.isSuper6GrayMode,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: 
                    _ctx.mWin === 9 ||
                        _ctx.mWin === 91 ||
                        _ctx.mWin === 92 ||
                        _ctx.mWin === 93 ||
                        _ctx.mWin === 10 ||
                        _ctx.mWin === 101 ||
                        _ctx.mWin === 102 ||
                        _ctx.mWin === 103
                
      }, null, 8, ["chipValue", "tempAmount", "confirmedAMount", "currentIndex", "allowBet", "isGrayMode", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:11',
        betType: 7,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.redPairTemp,
        confirmedAMount: _ctx.redPairFinal,
        allowBet: _ctx.allowBet,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: _ctx.isRedPair
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "confirmedAMount", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:1',
        betType: 1,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.blueTemp,
        allowBet: _ctx.allowBet,
        confirmedAMount: _ctx.blueFinal,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: _ctx.isBlue
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "allowBet", "confirmedAMount", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: '1:8',
        betType: 2,
        offSet: -1,
        chipValue: _ctx.chipValue,
        currentIndex: _ctx.selectedBetArea,
        tempAmount: _ctx.greenTemp,
        allowBet: _ctx.allowBet,
        confirmedAMount: _ctx.greenFinal,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: _ctx.isGreen
      }, null, 8, ["chipValue", "currentIndex", "tempAmount", "allowBet", "confirmedAMount", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"]),
      _createVNode(_component_pc_bet_area, {
        class: "area",
        betRatio: _ctx.s6Mode ? '1:1' : '1:0.95',
        betType: _ctx.s6Mode ? 8 : 0,
        offSet: -1,
        chipValue: _ctx.chipValue,
        tempAmount: _ctx.s6Mode ? _ctx.redSuper6Temp : _ctx.redTemp,
        confirmedAMount: _ctx.redFinal,
        currentIndex: _ctx.selectedBetArea,
        allowBet: _ctx.allowBet,
        onPlaceBet: _ctx.OnPlaceBet,
        onCancelBet: _ctx.OnCancelBetTemp,
        onOnConfirmBet: _ctx.OnConfirmBet,
        showFlash: _ctx.isRed
      }, null, 8, ["betRatio", "betType", "chipValue", "tempAmount", "confirmedAMount", "currentIndex", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "showFlash"])
    ])
  ]))
})